import {CONNECT_AS_HEADER, readConnectAsSessionId} from '@ambler/shared-front'
import {STAFF_IDP_HINT} from './auth/session'

/**
 * The API's CSRF defence, required on every request carrying the session
 * cookie: no form of another site can set a header.
 */
export const API_VERSION_HEADERS = {'X-Api-Version': '7.0'}

/**
 * Every path reading the session cookie derives from this origin: a URL on
 * another site would lose the cookie without an error.
 */
export const apiOrigin = () => new URL(process.env.GRAPHQL_ENDPOINT).origin

export const apiUrl = (path: string) => `${apiOrigin()}${path}`

/** `idp`: a link opened without a session signs in through Google, not Keycloak's own page. */
export const secureFileUrl = (path: string) => {
  const url = new URL(apiUrl(`/sk${path}`))
  url.searchParams.set('idp', STAFF_IDP_HINT)

  return url.toString()
}

export const apiFetch = (url: string, init: Omit<RequestInit, 'headers'> & {headers?: Record<string, string>} = {}) => {
  const connectAsSessionId = readConnectAsSessionId()

  return fetch(url, {
    ...init,
    credentials: 'include',
    headers: {
      ...init.headers,
      ...API_VERSION_HEADERS,
      ...(connectAsSessionId ? {[CONNECT_AS_HEADER]: connectAsSessionId} : {}),
    },
  })
}
